import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import InnerHeader from "../Layout/InnerHeader";
import FileWatcherTestList from "./FileWatcherTestList";
import CustomLoadingButton from "../CustomComponents/CustomsButtons/CustomLoadingButton";

const FileWatcher = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleCreateNew = () => {
    navigate("create");
  };

  return (
    <>
      <InnerHeader>
        <Box width="100%" className="space-between">
          <Typography variant="h6">{t("File Watcher")}</Typography>
          <CustomLoadingButton color="success" onClick={handleCreateNew}>
            {t("Create New")}
          </CustomLoadingButton>
        </Box>
      </InnerHeader>

      <FileWatcherTestList />
    </>
  );
};

export default FileWatcher;
